export const COLLECTIVITE_SESSION = 'currentCollectivite';
export const TOKEN_SESSION = 'token_ixchange';
export const POLITIQUE_CONFIDENTIALITE_SESSION = 'politique_confidentialite';
export const ROLE_SESSION = 'role_ixchange';

// Session codes pour l'authentification utilisateur (mode session)
export const CODE_CLIENT_SESSION = 'codeClient';
export const CODE_POSTAL_SESSION = 'codePostal';
export const CODE_ACCES_SESSION = 'codeAcces';
